import { useFormSchema } from "src/api/hooks/useFormSchema";
import { WidgetProps } from "@rjsf/utils";
import { useState } from "react";
import { ConditionalWidgetProps } from "./ConditionalWidgetProps";

export const CheckboxWidget = (props: ConditionalWidgetProps) => {
  const { value, onChange, required, id } = props;
  const { data: schema } = useFormSchema();
  const primaryColor = schema?.theme?.colors?.primary || "#4CAF50";
  const [isAnimating, setIsAnimating] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsAnimating(true);
    onChange(e.target.checked);
    // Reset animation state after animation completes
    setTimeout(() => setIsAnimating(false), 600);
  };
  if (props.display) {
    return (
      <div className="checkbox-container container flex items-center ml-2">
        <div className="relative">
          <div
            className={`w-6 h-6 border-2 rounded-md flex items-center justify-center shadow-sm ${
              value
                ? "bg-PrimaryGreen border-PrimaryGreen shadow-md"
                : "bg-White border-Grey4"
            }`}
            style={{
              backgroundColor: value ? primaryColor : undefined,
              borderColor: value ? primaryColor : undefined,
            }}
          >
            {value && (
              <svg
                className="w-4 h-4 text-White"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M5 13l4 4L19 7"></path>
              </svg>
            )}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="checkbox-container container flex items-center ml-2">
      <style>{`
        @keyframes checkboxPulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.2);
          }
          100% {
            transform: scale(1);
          }
        }
        @keyframes checkmarkFadeIn {
          0% {
            opacity: 0;
            transform: scale(0.3) rotate(-45deg);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.1) rotate(5deg);
          }
          100% {
            opacity: 1;
            transform: scale(1) rotate(0deg);
          }
        }
        .checkbox-animate {
          animation: checkboxPulse 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        .checkmark-animate {
          animation: checkmarkFadeIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
      `}</style>
      <label
        htmlFor={id}
        className="flex items-center cursor-pointer group"
        style={{ userSelect: "none" }}
      >
        <div className="relative">
          <input
            id={id}
            type="checkbox"
            className="sr-only"
            checked={value || false}
            onChange={handleChange}
            required={required}
          />
          <div
            className={`w-6 h-6 border-2 rounded-md flex items-center justify-center shadow-sm ${
              value
                ? "bg-PrimaryGreen border-PrimaryGreen shadow-md"
                : "bg-White border-Grey4 group-hover:border-PrimaryGreen group-hover:shadow-md"
            } ${isAnimating ? "checkbox-animate" : ""}`}
            style={{
              backgroundColor: value ? primaryColor : undefined,
              borderColor: value ? primaryColor : undefined,
              transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
            }}
          >
            {value && (
              <svg
                className={`w-4 h-4 text-White ${
                  isAnimating ? "checkmark-animate" : ""
                }`}
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M5 13l4 4L19 7"></path>
              </svg>
            )}
          </div>
        </div>
      </label>
    </div>
  );
};
